// extracted by mini-css-extract-plugin
module.exports = {"notification-pane":"NotificationPane_notification-pane__ANo_e"};